{
  "title": "Sähköpostit",
  "table": {
    "sent_at": "Lähetetty",
    "recipient": "Vastaanottaja",
    "subject": "Aihe",
    "type": "Tyyppi",
    "status": "Tila"
  },
  "status": {
    "PENDING": "Odottaa",
    "SENT": "Lähetetty",
    "FAILED": "Epäonnistui"
  },
  "types": {
    "EMAIL_VERIFICATION": "Sähköpostin vahvistus",
    "PASSWORD_RESET": "Salasanan nollaus",
    "COMPETITION_REGISTRATION_CONFIRMED": "Ilmoittautuminen vahvistettu",
    "COMPETITION_REGISTRATION_WAITLISTED": "Ilmoittautuminen varasijalle",
    "COMPETITION_REGISTRATION_CANCELLED": "Ilmoittautuminen peruttu",
    "COMPETITION_REGISTRATION_WAITLIST_CONFIRMED": "Varasijalta vahvistettu",
    "COMPETITION_START_TIMES_PUBLISHED": "Lähtöajat julkaistu",
    "ROUND_RESULTS_PUBLISHED": "Kierroksen tulokset julkaistu",
    "COMPETITION_PARTICIPANT_ADHOC": "Viesti osallistujille",
    "FEEDBACK": "Käyttäjäpalaute",
    "EMAIL_CHANGE_CONFIRMATION": "Sähköpostin vaihdon vahvistus",
    "EMAIL_CHANGE_NOTICE": "Ilmoitus sähköpostin vaihdosta"
  },
  "popover": {
    "body_label": "Viesti",
    "error_message_label": "Virheviesti"
  },
  "pagination": {
    "previous": "Edellinen",
    "next": "Seuraava",
    "page_of": "Sivu {{current}} / {{total}}"
  },
  "not_sent_yet": "(ei lähetetty)",
  "empty_state": "Ei sähköposteja",
  "refresh": "Päivitä",
  "view_details": "Näytä tiedot",
  "copy_body": "Kopioi leikepöydälle"
}
